export default {"src":"/_next/static/media/mascot-longing.c23fffb3.gif","height":200,"width":200,"blurWidth":0,"blurHeight":0};